export default {
  noActiveCalls: 'No active calls',
  noRecords: 'No results found.',
} as const;
